import { useCallback, useState } from 'react'

import { LuMove } from 'react-icons/lu'
import { MdDeleteOutline } from 'react-icons/md'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'

import { useListMutations } from '../../hooks/useListMutations.ts'
import type { TikTokContentListType } from '../../videos/ui/types'
import type { SelectedListItemsMap } from '../types'

interface Props {
  selectedItems: SelectedListItemsMap
  currentList: TikTokContentListType
  onActionSuccess: () => void
}

export const SelectedItemsActions = ({
  selectedItems,
  currentList,
  onActionSuccess,
}: Props) => {
  const [showActions, setShowActions] = useState(false)
  const { removeItemsFromList } = useListMutations()

  const handleRemoveItemsFromList = useCallback(async () => {
    await removeItemsFromList.mutateAsync({
      listId: Number(currentList.id),
      itemsIds: {
        soundIds: Array.from(selectedItems.sounds.keys()),
        postIds: Array.from(selectedItems.posts.keys()),
      },
    })

    onActionSuccess()
  }, [
    currentList.id,
    onActionSuccess,
    removeItemsFromList,
    selectedItems.posts,
    selectedItems.sounds,
  ])

  const selectedItemsCount = [
    ...selectedItems.sounds.values(),
    ...selectedItems.posts.values(),
  ].filter(Boolean).length

  const openEditModal = () => {
    openDialog({
      type: DIALOG_TYPE.MORE_TIKTOK_VIDEO_OR_SOUNDS_DIALOG,
      selectedItems,
      currentList,
      onActionSuccess,
    })
  }

  return (
    !!selectedItemsCount && (
      <div className="fixed bottom-10 left-1/2 -translate-x-1/2 lg:left-[calc(150px+50%)]">
        <DropdownMenu
          open={showActions}
          onOpenChange={setShowActions}
        >
          <DropdownMenuTrigger>
            <Button>Action</Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            forceMount
            side="top"
            sideOffset={8}
            className="border-none px-2 py-[10px]"
          >
            <DropdownMenuGroup className="flex flex-col items-center">
              <DropdownMenuItem
                onClick={openEditModal}
                disabled={removeItemsFromList.isLoading}
              >
                <LuMove />
                Move Videos or Sounds
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={handleRemoveItemsFromList}
                disabled={removeItemsFromList.isLoading}
              >
                <MdDeleteOutline />
                Remove from List
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    )
  )
}
